"use client";

import Image from "next/image";
import React from "react";

import LabelButtonWrapper from "@/components/atoms/button-wrapper/button-wrapper";
import TrustPilotImage from "@/public/images/trustpilot-brandmark.svg";
import { TrustPilotContentProps } from "@/types/confirmation-types";

import Styles from "./trust-pilot.module.css";

function TrustPilotContent({
  trustPilotTitle,
  trustPilotContent,
  trustPilotBtnLabel,
  trustPilotBtnLabelTwo,
}: Readonly<TrustPilotContentProps>) {
  const onClickHandler = () => {
    window.open(trustPilotBtnLabelTwo, "_blank");
  };

  return (
    <div>
      <div className=" bg-surface-neutral-option-1 rounded-radius-xxl p-spacing-m md:p-spacing-l lg:p-spacing-xl space-y-spacing-s md:space-y-spacing-m h-fit">
        <div className="flex flex-col gap-spacing-l">
          <Image
            className="rounded-xl"
            src={TrustPilotImage}
            alt="banner image"
          />

          <h1 className="flex flex-row justify-between font-header-font text-text-title text-[23px] md:text-[31px] leading-[27.6px] md:leading-[34.1px]">
            {trustPilotTitle}
          </h1>

          <div>
            <p className="text-xs font-normal leading-custom-size-xxl text-text-body">
              {trustPilotContent}
            </p>
          </div>
          <div className={Styles.trustPilot}>
            {trustPilotBtnLabelTwo && (
              <LabelButtonWrapper
                data-testid="trust-pilot-button"
                id="trust-pilot-button"
                isDisabled={false}
                label={trustPilotBtnLabel ?? ""}
                hierarchy="secondary"
                className={`${Styles.reviewBtn} !w-fit px-spacing-l py-spacing-s bg-dark-text-on-secondary leading-custom-size-xs`}
                type="button"
                onClick={onClickHandler}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TrustPilotContent;
